/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_SubtitleInputs */

const vi_shop_tier_subtitle = /** @type {(inputs: Shop_Tier_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áp dụng cho khách bán lẻ cả web và Zalo Mini App; khách ở hạng có mốc chi tiêu cao nhất đã đạt.`)
};

/**

* @param {Shop_Tier_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_subtitle = /** @type {((inputs?: Shop_Tier_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_subtitle(inputs)
});